document.addEventListener("DOMContentLoaded", () => {
	if (window.location.pathname !== "/") {
		const pageTitle = document.querySelector(".page-banner__title:not(.recipe-title)");
		const bannerSubtitle = document.querySelector("[data-banner-subtitle]");
		const bannerText = document.querySelector("[data-banner-text]");
		const productDescription = document.querySelector(".page-banner__product-description");

		if (!bannerSubtitle && !bannerText && !productDescription) {
			pageTitle.style.margin = "0";
		}
	}
});
